export default __webpack_public_path__ + "static/media/Kunga.d2213436.jpeg";